export const POST_SIGNOUT_ROUTE_KEY = 'post_signout_route'
export const POST_SIGNOUT_REDIRECT_URL_KEY = 'post_signout_redirect_url'
export const CUSTOM_STATE_STORAGE_KEY = 'auth_custom_state'
export const COMPLETE_SIGN_IN_RESET_DELAY_MS = 2000
export const ACTIVE_AUTH_CONTEXT_STORAGE_KEY = 'entra_active_auth_context'
export const PENDING_AUTH_CONTEXT_STORAGE_KEY = 'entra_pending_auth_context'
export const REMEMBER_SIGN_IN_EMAIL_ENABLED_KEY = 'remember_sign_in_email_enabled'
export const REMEMBER_SIGN_IN_EMAIL_KEY = 'remember_sign_in_email'
